import { DATA_MODEL_TABLE as BASE_DATA_MODEL_TABLE } from "@digitallab/grid-common-frontend-components";

const DATA_MODEL_TABLE = {
  ...BASE_DATA_MODEL_TABLE,
  contactPerson: { key: "contactPerson", value: "Contact person" },
  dateOfLastCalibration: { key: "dateOfLastCalibration", value: "Last calibration date" },
  description: { key: "description", value: "Description" },
  maintenancePerformedBy: { key: "maintenancePerformedBy", value: "Maintenance performed by" },
  portability: { key: "portability", value: "Portability" },
  equipmentType: { key: "equipmentType", value: "Equipment type" },
};

export default DATA_MODEL_TABLE;
